/**
 * Festive Collection — pin the section and convert vertical scroll
 * into a horizontal product rail, matching the Figma Make sticky track.
 */
(function () {
  // Matches the stacked-layout breakpoint in assets/section-kk-festive.css.
  const DESKTOP = '(min-width: 990px)';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function setup(root) {
    const rail = root.querySelector('[data-kk-festive-rail]');
    const viewport = root.querySelector('[data-kk-festive-viewport]');
    const fill = root.querySelector('[data-kk-festive-fill]');
    const cards = root.querySelectorAll('[data-kk-festive-card]');
    if (!rail || !viewport || !cards.length) return;

    let travel = 0;
    let ticking = false;

    function canPin() {
      return window.matchMedia(DESKTOP).matches && !prefersReducedMotion();
    }

    function setActive(progress, index) {
      const last = cards.length - 1;
      const pick = typeof index === 'number' ? index : Math.round(progress * last);
      const active = Math.min(last, Math.max(0, pick));
      cards.forEach(function (card, index) {
        card.classList.toggle('is-active', index === active);
      });
      if (fill) fill.style.width = Math.max(8, progress * 100) + '%';
    }

    function measure() {
      const pin = canPin();
      root.classList.toggle('is-pinned', pin);
      if (!pin) {
        root.style.height = '';
        rail.style.setProperty('--festive-x', '0px');
        root.style.setProperty('--festive-parallax', '0px');
        setActive(0);
        return;
      }
      rail.style.setProperty('--festive-x', '0px');
      const lastCard = cards[cards.length - 1];
      const railLeft = rail.getBoundingClientRect().left;
      const endPad = parseFloat(window.getComputedStyle(rail).paddingRight) || 0;
      const contentWidth = lastCard.offsetWidth + (lastCard.getBoundingClientRect().left - railLeft) + endPad;
      travel = Math.max(0, Math.round(contentWidth - viewport.clientWidth));
      root.style.height = travel > 0 ? window.innerHeight + travel + 'px' : '';
      update();
    }

    function update() {
      if (!root.classList.contains('is-pinned') || travel <= 0) return;
      const distance = root.offsetHeight - window.innerHeight;
      if (distance <= 0) return;
      const progress = Math.max(0, Math.min(1, -root.getBoundingClientRect().top / distance));
      rail.style.setProperty('--festive-x', -progress * travel + 'px');
      root.style.setProperty('--festive-parallax', (progress - 0.5) * 20 + 'px');
      root.style.setProperty('--festive-overlay', String(0.82 - progress * 0.12));
      setActive(progress);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        if (canPin()) {
          update();
        } else {
          const max = viewport.scrollWidth - viewport.clientWidth;
          const progress = max > 0 ? viewport.scrollLeft / max : 0;
          const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : 0;
          let index = step > 0 ? Math.round(viewport.scrollLeft / step) : 0;
          if (max > 0 && viewport.scrollLeft >= max - 2) index = cards.length - 1;
          setActive(progress, index);
        }
        ticking = false;
      });
    }

    viewport.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure, { passive: true });
    rail.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', measure, { once: true });
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    if (document.readyState === 'complete') measure();
    else window.addEventListener('load', measure);
    if ('ResizeObserver' in window) {
      let queued = false;
      const observer = new ResizeObserver(function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () {
          queued = false;
          measure();
        });
      });
      observer.observe(viewport);
      cards.forEach(function (card) { observer.observe(card); });
    }
    window.requestAnimationFrame(measure);
    setActive(0);
  }

  function boot() {
    document.querySelectorAll('[data-kk-festive]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('[data-kk-festive]');
    if (root) setup(root);
  });
})();
